import React from "react";

import * as Styled from "./styles";
import { Container } from "@mui/material";
import { BoxStep } from "components/BoxStep";
import { dataStep } from "shared/data/steps";
import { useMetrus } from "shared/providers";
import { FormHome } from "components/FormHome";

const HomeContent: React.FC = () => {
  const {
    step,
    list,
    /*setInsuranceIdNext, setPreferr*/ setState,
    setCityId,
    setNeighId,
    setProviderId,
    setSpecialistId,
    setNameProviderId,
    setPage,
    setStep,
  } = useMetrus();

  /*const backPlan = () => {
    setInsuranceIdNext(0);
    setPreferr("NOT_DEFINED");
  };*/

  const backLocal = () => {
    setState("");
    setCityId("");
    setNeighId("");
    setProviderId("");
    setSpecialistId("");
    setNameProviderId("");
    setProviderId("");
    setPage(1);
    setStep(2);
  };

  const backSpecialist = () => {
    setSpecialistId("");
    setNameProviderId("");
    setProviderId("");
    setPage(1);
    setStep(3);
  };

  const fakeClick = () => {};

  return (
    <Container maxWidth="xl">
      {list ? (
        ""
      ) : (
        <Styled.Content>
          {dataStep.map((item, index) => (
            <BoxStep
              key={index}
              data={item}
              active={step === item.active || step > item.active}
              onClick={
                item.active === 2 && step > 2
                  ? backLocal
                  : item.active === 3 && step > 3
                  ? backSpecialist
                  : fakeClick
              }
            />
          ))}
        </Styled.Content>
      )}
      <FormHome />
    </Container>
  );
};

export { HomeContent };
